import { useCallback } from 'react';

import { aiExperiencePromptActionPluginKey } from '../../../../pm-plugins/prompt-action/prompt-action-plugin-key';
import { ACTIONS } from '../../../../pm-plugins/prompt-action/states';
import type { ActionType } from '../../../../pm-plugins/prompt-action/states';
import type { AIExperienceMachineContext } from '../../../utils/xstate/get-ai-experience-service';

export const useShowActionFlag = (aiExperienceMachineContext: AIExperienceMachineContext) => {
	return useCallback(
		(actionTitle: ActionType, prompt: string) => {
			// Dispatch transaction directly to update plugin state
			const tr = aiExperienceMachineContext.editorView.state.tr;
			tr.setMeta(aiExperiencePromptActionPluginKey, {
				type: ACTIONS.ACTION_COMPLETED,
				data: {
					actionType: actionTitle,
					prompt,
				},
			});

			aiExperienceMachineContext.editorView.dispatch(tr);
		},
		[aiExperienceMachineContext.editorView],
	);
};
